import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PaymentService } from 'src/app/service/payment.service';
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  constructor(
    private paymentserv: PaymentService,
    private sanitized: DomSanitizer
  ) { }

  ngOnInit(): void {
   
  }

}
